/* @flow strict */

import * as React from 'react';
import Preloader from '../Preloader';

import './styles.scss';

const GlobalError = ({}: PropsType): React.Element<typeof React.Fragment> => {
  return (
    <div className='Service-msg GlobalError'>
      <Preloader type='for-global-error' />
      <h1>Sorry, this page isn't available</h1>
      <h4>
        Something went wrong. Try again later. &nbsp;
        <a href='/'>Or try to reload page</a>
      </h4>
    </div>
  );
};

export default GlobalError;
